import { FC } from 'react';
import './../Tab1General/Tab1General.scss';

interface ILoadInput {
  noFakeLabel?: boolean;
}

const LoadInput: FC<ILoadInput> = ({ noFakeLabel }: ILoadInput) => {
  return (
    <div className="loadingIput">
      {!noFakeLabel && <div className="fakeLabel" />}
      <div className="fakeInput animationLoader" />
    </div>
  );
};

const Tab1Loader = () => {
  const headerDetail = document.getElementById('headerdDetail');

  return (
    <section
      className="tabContent pt-6"
      style={{ height: `calc(100% - ${headerDetail?.clientHeight}px)`, overflow: 'auto' }}
    >
      <div className="tab1General">
        <div className="organizationInfo">
          <div className="generalTitle mb-2">Información de empresa</div>
          <div className="organizationDetails">
            <div className="containerFlag">
              <LoadInput />
            </div>
            <div className="organizationName">
              <LoadInput />
            </div>
            <div className="organizationDocument">
              <LoadInput />
            </div>
          </div>
          <div className="bigGrayLine" />
        </div>
        <div className="clientInfo">
          <div className="generalTitle mb-2">Información del cliente</div>
          <div className="clientInfoDetail">
            <div className="mediumInput">
              <LoadInput />
            </div>
            <div className="mediumInput">
              <LoadInput />
            </div>
            <div className="smallInput">
              <LoadInput />
            </div>
            <div className="bigInput">
              <LoadInput />
            </div>
            <div className="extraBigInput">
              <LoadInput />
            </div>
          </div>
          <div className="bigGrayLine" />
        </div>
        <div className="paymentInfo">
          <div className="generalTitle mb-2">Información del cliente</div>
          <div className="labelPaymentMethod w-32 animationLoader" />
          <div className="paymentInfoDetail">
            <div className="bigInput">
              <LoadInput />
            </div>
            <div className="mediumInput">
              <LoadInput />
            </div>
            <div className="smallInput">
              <LoadInput />
            </div>
            <div className="smallInput">
              <LoadInput />
            </div>
          </div>
          <div className="paymentDownDetail">
            <div className="bigUpload">
              <LoadInput noFakeLabel />
            </div>
          </div>
          <div className="bigGrayLine" />
        </div>
      </div>
    </section>
  );
};

export default Tab1Loader;
